import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "context/UserContext";

export const PublicLayout = () => {
  const { usuarioLogado } = useContext(UserContext);

  if (usuarioLogado && usuarioLogado.id) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <Outlet />
    </div>
  );
};
